import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import isEmpty from 'lodash/isEmpty';
import { di } from 'react-magnetic-di';
import { FieldValueLookupError } from '../../../../../common/utils/errors/field-value-lookup-error';
import { getSupportedFieldConfiguration } from '../../../../view-configuration';
import { FIELD_VALIDATION_ERROR } from '../../../utils/errors/constants';
import { mapFieldPropertyToApiMethod } from '../../../utils/map-field-property-to-api-method';
import { VALID_RESULT } from './constants';
import { filterInvalidResults, mapValidResultsToFieldInternalShape } from './utils';
export var transformFieldChangesToInternalShape = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var fieldType, fieldId, fieldFromIframe, lookupData, viewType, tenantContext, executionContext, environment, intl, fieldConfiguration, fieldTransformers, fieldValidators, validatorsArray, lookupSource, lookupValues, fieldTransformationResults, invalidTransformationResults;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          fieldType = _ref.fieldType, fieldId = _ref.fieldId, fieldFromIframe = _ref.fieldFromIframe, lookupData = _ref.lookupData, viewType = _ref.viewType, tenantContext = _ref.tenantContext, executionContext = _ref.executionContext, environment = _ref.environment, intl = _ref.intl;
          fieldConfiguration = getSupportedFieldConfiguration(viewType, fieldType);
          fieldTransformers = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicToInternalTransformers;
          fieldValidators = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicShapeValidators;
          if (!(!fieldFromIframe || !fieldTransformers || !fieldValidators)) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return", _objectSpread(_objectSpread({}, VALID_RESULT), {}, {
            data: {}
          }));
        case 6:
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          validatorsArray = Object.keys(fieldValidators);
          lookupSource = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.lookupSource; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore - lookupData is not types on CI somehow
          lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
          _context2.next = 11;
          return Promise.all(validatorsArray.map( /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(propertyName) {
              var propertyValue, transformer, fieldContext, data, faultyValue;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) {
                      _context.next = 2;
                      break;
                    }
                    return _context.abrupt("return", VALID_RESULT);
                  case 2:
                    propertyValue = fieldFromIframe[propertyName];
                    transformer = fieldTransformers[propertyName];
                    fieldContext = {
                      fieldId: fieldId
                    }; // We need to catch lookup values discrepancies and react accordingly
                    // to how we react to validation errors - throw an error
                    // if the set value wasn't found in the array of lookupValues
                    _context.prev = 5;
                    if (!transformer) {
                      _context.next = 12;
                      break;
                    }
                    _context.next = 9;
                    return transformer(propertyValue, lookupValues, {
                      tenantContext: tenantContext,
                      executionContext: executionContext,
                      environment: environment,
                      fieldContext: fieldContext,
                      intl: intl
                    });
                  case 9:
                    _context.t0 = _context.sent;
                    _context.next = 13;
                    break;
                  case 12:
                    _context.t0 = propertyValue;
                  case 13:
                    data = _context.t0;
                    return _context.abrupt("return", {
                      isValid: true,
                      data: _defineProperty({}, propertyName, data)
                    });
                  case 17:
                    _context.prev = 17;
                    _context.t1 = _context["catch"](5);
                    if (!(_context.t1 instanceof FieldValueLookupError)) {
                      _context.next = 22;
                      break;
                    }
                    // For single value fields its straightforward to just pass
                    // the faulty propertyValue into error message,
                    // but for multi value fields we should find out the faulty values from the array
                    // thats why we should propagate the faulty values as a comma separated string
                    // by using the error's message
                    faultyValue = _context.t1.message || propertyValue;
                    return _context.abrupt("return", {
                      isValid: false,
                      error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: FIELD_VALIDATION_ERROR,
                        method: mapFieldPropertyToApiMethod(propertyName),
                        message: "Invalid IDs provided: ".concat(faultyValue)
                      }
                    });
                  case 22:
                    throw _context.t1;
                  case 23:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[5, 17]]);
            }));
            return function (_x2) {
              return _ref3.apply(this, arguments);
            };
          }()));
        case 11:
          fieldTransformationResults = _context2.sent;
          invalidTransformationResults = filterInvalidResults(fieldTransformationResults);
          if (isEmpty(invalidTransformationResults)) {
            _context2.next = 15;
            break;
          }
          return _context2.abrupt("return", {
            isValid: false,
            errors: invalidTransformationResults.map(function (result) {
              return result.error;
            })
          });
        case 15:
          return _context2.abrupt("return", mapValidResultsToFieldInternalShape(fieldTransformationResults));
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function transformFieldChangesToInternalShape(_x) {
    return _ref2.apply(this, arguments);
  };
}();